// Conteúdo oficial extraído do documento fornecido pela empresa.
export default {
  "title": "O QUE É SER UM CORRETOR 61",
  "eyebrow": "03 / MISSÃO & CULTURA",
  "intro": [
    "Ser um corretor associado à 61 Imóveis é assumir o compromisso de ser protagonista da própria carreira, seguindo método, processos e padrões de excelência.",
    "Na 61, todos representamos a marca. Por isso, cada corretor é responsável por aplicar nosso método com ética, excelência e colaboração, fortalecendo seus próprios resultados e a reputação de toda a equipe.",
    "A atuação de um Corretor 61 baseia-se em 9 compromissos fundamentais:"
  ],
  "commitments": [
    "Cumprir os processos, metodologias, ações e normas estabelecidas pela empresa e pelos gerentes.",
    "Manter uma postura ética e estritamente profissional em todas as interações.",
    "Respeitar clientes, colegas de profissão, gestores e colaboradores.",
    "Manter os cadastros de clientes e imóveis sempre atualizados.",
    "Preservar e valorizar a imagem e a marca da 61 Imóveis.",
    "Atuar sempre em prol dos interesses da empresa e da segurança dos clientes.",
    "Participar ativamente dos treinamentos e reuniões comerciais.",
    "Utilizar corretamente as ferramentas, sistemas e a estrutura oferecida.",
    "Contribuir ativamente para a manutenção de um ambiente de trabalho colaborativo."
  ],
  "ethicsIntro": "Na 61 Imóveis, a ética não é apenas uma obrigação, é a forma como construímos confiança, relacionamentos duradouros e resultados sólidos. Este é o nosso padrão inegociável de conduta:",
  "ethics": [
    {
      "title": "SEJA TRANSPARENTE",
      "paragraphs": [
        "Fale sempre a verdade. Apresente informações corretas sobre imóveis, negociações e processos, sem criar expectativas falsas ou que não possam ser cumpridas."
      ]
    },
    {
      "title": "CLIENTE EM PRIMEIRO LUGAR",
      "paragraphs": [
        "Ouça, oriente e conduza cada negociação pensando na melhor experiência e segurança para o cliente."
      ]
    },
    {
      "title": "RESPEITE SEUS COLEGAS",
      "paragraphs": [
        "Acreditamos em parceria, e na competição interna saudável. Valorize o trabalho dos demais corretores, cumpra os acordos de coparticipação rigorosamente e mantenha um ambiente colaborativo."
      ]
    },
    {
      "title": "PRESERVE INFORMAÇÕES CONFIDENCIAIS",
      "paragraphs": [
        "Dados de clientes, imóveis, campanhas, estratégias comerciais, indicadores e documentos internos são patrimônio da empresa e devem ser tratados com absoluto sigilo, mesmo após o encerramento da parceria."
      ]
    },
    {
      "title": "UTILIZE A ESTRUTURA COM RESPONSABILIDADE",
      "paragraphs": [
        "O CRM, Imoview, equipamentos (crachás, chaves, controles) e materiais institucionais existem para potencializar o seu trabalho. Utilize-os de forma responsável e devolva-os em caso de término da parceria."
      ]
    },
    {
      "title": "FAÇA O CERTO, MESMO QUANDO NINGUÉM ESTÁ OLHANDO",
      "paragraphs": [
        "Na 61, integridade não depende de fiscalização ou da conduta dos outros.",
        "“O certo é certo, mesmo que ninguém esteja olhando; e o errado continua sendo errado, mesmo que todos estejam fazendo.”"
      ]
    },
    {
      "title": "NUNCA \"QUEIME\" UM IMÓVEL",
      "paragraphs": [
        "Evite qualquer comentário que desvalorize um imóvel, um colega ou uma negociação. Nosso papel é orientar o cliente com profissionalismo e imparcialidade absoluta."
      ]
    },
    {
      "title": "SEJA PROTAGONISTA",
      "paragraphs": [
        "Busque conhecimento constante, assuma suas responsabilidades e faça acontecer."
      ]
    },
    {
      "title": "RESPEITE A ATUAÇÃO DOS COLEGAS",
      "paragraphs": [
        "Se outro corretor já estiver conduzindo uma negociação ou tiver sinalizado interesse no imóvel, respeite essa atuação. Não realize a captação de um imóvel que esteja vedado para nova captação."
      ]
    },
    {
      "title": "RESPEITE CONTRATOS DE EXCLUSIVIDADE",
      "paragraphs": [
        "Nunca oriente ou incentive um cliente a cancelar uma exclusividade vigente com outro corretor ou imobiliária."
      ]
    }
  ],
  "rightsIntro": "Ao fazer parte da 61 Imóveis, o corretor parceiro não tem custos com a estrutura básica de trabalho e passa a ter direito a um ecossistema completo focado em alta performance. Você tem direito a:",
  "rights": [
    {
      "title": "ESTRUTURA COMPLETA PARA ATUAR",
      "paragraphs": [
        "Espaço Físico:\nUtilização de toda a estrutura da empresa.",
        "Atendimento:\nSalas de reunião e negociação preparadas para receber os clientes.",
        "Recursos:\nInternet de alta velocidade, sistemas corporativos e acesso à sala de impressão para retirada de materiais de prospecção (Books, envelopes e cartas)."
      ],
      "placeholder": false
    },
    {
      "title": "TECNOLOGIA E FERRAMENTAS",
      "paragraphs": [
        "C2S (CRM):\nAplicativo e sistema para recebimento de leads.",
        "Imoview:\nPlataforma para gestão da carteira de imóveis.",
        "Inteligência 61:\nSistema próprio e exclusivo da 61 Imóveis. Inclui o App de Captação, lançamento obrigatório de visitas, acompanhamento de metas e muito mais."
      ],
      "placeholder": false
    },
    {
      "title": "APOIO ESPECIALIZADO (SETORES A SEU FAVOR)",
      "paragraphs": [
        "- Hub Administrativo\n- Marketing\n- Departamento de Pós-Contrato\n- Inteligência Imobiliária"
      ],
      "placeholder": false
    },
    {
      "title": "DESENVOLVIMENTO PROFISSIONAL",
      "paragraphs": [],
      "placeholder": true
    }
  ],
  "responsibilityIntro": "Ao integrar a 61 Imóveis, cada corretor assume o compromisso de representar a empresa com profissionalismo, organização e responsabilidade em todas as etapas da negociação. É responsabilidade do corretor:",
  "responsibilities": [
    {
      "title": "PROCESSOS INTERNOS",
      "items": [
        "Cumprir os processos, normas e procedimentos estabelecidos pela empresa;",
        "Respeitar os fluxos operacionais e administrativos;",
        "Manter seus cadastros e informações atualizados nos sistemas;",
        "Utilizar corretamente o CRM, Imoview e demais ferramentas disponibilizadas pela empresa;",
        "Participar dos treinamentos e manter-se em constante desenvolvimento profissional.",
        "Cumprir as atividades previamente definidas para o corretor."
      ]
    },
    {
      "title": "GESTÃO E QUALIDADE DOS IMÓVEIS",
      "items": [
        "Garantir a qualidade, padronização e atualização das informações dos imóveis;",
        "Manter preços, disponibilidade, características e demais informações sempre atualizados;",
        "Assegurar que os imóveis atendam aos padrões de qualidade da 61 Imóveis antes da divulgação;",
        "Acompanhar a gestão completa dos imóveis sob sua responsabilidade;",
        "Realizar análises relacionadas ao programa Imóvel Seguro;",
        "Revisar periodicamente os anúncios para mantê-los corretos, atualizados e competitivos.",
        "Identificar pendências documentais e acompanhar sua regularização.",
        "Acompanhar a entrega da posse e das chaves, garantindo o cumprimento de todas as obrigações contratuais."
      ]
    },
    {
      "title": "DIVULGAÇÃO E ESTOQUE",
      "items": [
        "Publicar os imóveis nos canais de divulgação que não são disponibilizados pela 61 Imóveis;",
        "Acompanhar a qualidade e o desempenho dos anúncios;",
        "Solicitar e acompanhar ensaios fotográficos, vídeos e demais materiais necessários para divulgação.",
        "Conferir todas as informações cadastrais antes da publicação.",
        "Controlar imóveis exclusivos, em negociação, vendidos e indisponíveis.",
        "Realizar a requalificação periódica do estoque imobiliário.",
        "Conferir a padronização dos títulos, descrições, fotografias e informações dos anúncios."
      ]
    },
    {
      "title": "RELACIONAMENTO COM CLIENTES E PROPRIETÁRIOS",
      "items": [
        "Manter relacionamento profissional com proprietários e clientes;",
        "Acompanhar o proprietário durante todo o processo de comercialização;",
        "Responder clientes com agilidade, cordialidade e transparência;",
        "Acompanhar visitas e negociações até sua conclusão;",
        "Manter o cliente informado durante todas as etapas da negociação.",
        "Apresentar relatórios de visitas e acessos aos imóveis.",
        "Manter os clientes vendedores informados sobre o acompanhamento e a evolução das visitas e oportunidades."
      ]
    },
    {
      "title": "RESPONSABILIDADE COM A EMPRESA",
      "items": [
        "Preservar o patrimônio físico, tecnológico e intelectual da 61 Imóveis;",
        "Utilizar recursos e ferramentas da empresa com responsabilidade;",
        "Contribuir para um ambiente colaborativo, respeitando colegas, gestores e equipes;",
        "Atuar com comprometimento, organização e senso de responsabilidade em todas as atividades.",
        "Manter o CRECI regular - A multa é do corretor."
      ]
    },
    {
      "title": "PÓS-CONTRATO",
      "items": [
        "Permanecer disponível para apoiar compradores, vendedores e o setor de Pós-Contrato sempre que necessário.",
        "Acompanhar o andamento da negociação e manter contato com o cliente durante todo o processo de Pós-Contrato.",
        "Auxiliar na resolução de pendências, quando solicitado pelo setor de Pós-Contrato ou pelo Gerente.",
        "Acompanhar a avaliação realizada pelo agente financiador.",
        "Acompanhar a vistoria realizada pelo banco.",
        "Acompanhar a vistoria final do imóvel antes da entrega das chaves.",
        "Comparecer presencialmente à assinatura da escritura, salvo autorização do Gerente Comercial.",
        "Comparecer presencialmente à entrega das chaves, garantindo uma boa experiência para as partes e o encerramento adequado da negociação."
      ]
    }
  ],
  "propertyResponsibility": "TODO O GERENCIAMENTO DO IMÓVEL É DE RESPONSABILIDADE DO CORRETOR.",
  "brandResponsibility": "Na 61 Imóveis, todos representam a marca. Cada atendimento, visita, anúncio e negociação fortalece a reputação construída pela empresa ao longo dos anos.",
  "sectors": [
    {
      "title": "DIRETORIA COMERCIAL",
      "intro": [
        "Responsável por definir as estratégias comerciais da empresa, impulsionar o crescimento sustentável dos resultados e garantir que toda a operação comercial funcione de forma integrada. Atua como principal responsável pelo direcionamento da força de vendas, estabelecendo metas, indicadores, processos e prioridades para que a empresa alcance seus objetivos.",
        "Sua atuação envolve decisões estratégicas, análise constante de desempenho e desenvolvimento das lideranças, assegurando que a metodologia comercial da 61 Imóveis seja executada com excelência em todas as unidades."
      ],
      "groups": [
        {
          "title": "PRINCIPAIS RESPONSABILIDADES DA DIRETORIA COMERCIAL",
          "items": [
            "Definir as estratégias comerciais da empresa.",
            "Elaborar o planejamento comercial anual, trimestral e mensal.",
            "Estabelecer metas e objetivos para toda a operação comercial.",
            "Garantir a execução da metodologia comercial da 61 Imóveis em todas as unidades.",
            "Direcionar, acompanhar e desenvolver os Gerentes Comerciais.",
            "Desenvolver e fortalecer as lideranças da empresa.",
            "Acompanhar diariamente os indicadores de desempenho (KPIs).",
            "Monitorar produtividade, desempenho e resultados de corretores, gerentes e unidades.",
            "Analisar resultados, identificar oportunidades e definir planos de ação.",
            "Impulsionar o aumento de captações, visitas, propostas, vendas e exclusividades.",
            "Monitorar diariamente os principais indicadores comerciais da empresa."
          ]
        }
      ]
    },
    {
      "title": "HUB ADMINISTRATIVO",
      "intro": [
        "O Hub Administrativo é o setor responsável por centralizar e executar os processos administrativos que dão suporte à operação comercial da 61 Imóveis. Sua função é garantir que corretores e gerentes tenham todo o apoio operacional necessário para dedicar seu tempo ao que realmente gera resultado: captar imóveis, atender clientes e fechar negócios.",
        "O Hub atua como um centro de apoio, executando solicitações, organizando informações, garantindo a padronização dos processos e assegurando que toda a operação aconteça de forma organizada, segura e eficiente.",
        "Importante: o HUB executa processos administrativos e operacionais. A responsabilidade pelo imóvel, pelas informações cadastradas e pela condução da negociação é do corretor."
      ],
      "groups": [
        {
          "title": "PRINCIPAIS RESPONSABILIDADES DO HUB ADMINISTRATIVO",
          "items": [
            "Centralizar e executar todos os processos administrativos que dão suporte à operação comercial.",
            "Garantir que corretores e gerentes tenham suporte operacional para focar em captação, atendimento e vendas.",
            "Assegurar a padronização dos imóveis.",
            "Emitir certidões de compradores, vendedores e imóveis.",
            "Solicitar matrículas atualizadas e inscrições imobiliárias.",
            "Realizar pesquisas de ônus reais e análises documentais.",
            "Emitir assertivas para apoio às negociações.",
            "Realizar análises do Programa Imóvel Seguro e emitir pareceres de segurança.",
            "Organizar e manter o histórico documental dos imóveis e clientes.",
            "Auxiliar os corretores no cadastro de imóveis nos sistemas da empresa, seguindo os padrões estabelecidos.",
            "Publicar imóveis nos portais imobiliários.",
            "Enviar os links dos anúncios aos corretores e gerentes.",
            "Auxiliar na produção de books de apresentação e materiais de apoio comercial, quando solicitado pelo gerente.",
            "Imprimir cartas, etiquetas e demais materiais utilizados pela equipe comercial, quando solicitado pelo gerente.",
            "Organizar e controlar materiais físicos de apoio às operações.",
            "Disponibilizar listas de clientes para ações de prospecção, quando solicitado pelo gerente.",
            "Controlar o recebimento, a distribuição e o acompanhamento dos leads provenientes dos portais imobiliários.",
            "Realizar auditorias internas nos cadastros e anúncios publicados por demanda da diretoria.",
            "Garantir a conformidade dos processos administrativos com os padrões da empresa.",
            "Desenvolver e atualizar procedimentos, checklists e fluxos operacionais.",
            "Integrar as atividades do HUB com os setores Comercial, Marketing, Jurídico, Financeiro e Tecnologia.",
            "Atuar como suporte técnico e administrativo para corretores, gerentes e diretoria.",
            "Elaborar relatórios gerenciais sobre estoque, captações, anúncios, documentação e produtividade.",
            "Monitorar indicadores de desempenho do setor, como tempo de cadastro, tempo de publicação, qualidade dos anúncios, requalificação do estoque e produtividade da equipe.",
            "Identificar gargalos operacionais, propor melhorias e implementar ações para aumentar a eficiência dos processos.",
            "Garantir a segurança das informações, a organização dos processos e a excelência operacional que sustentam toda a operação comercial da 61 Imóveis."
          ]
        }
      ]
    },
    {
      "title": "PÓS-CONTRATO",
      "intro": [
        "Acompanha todo o processo após a assinatura do contrato, prestando suporte às partes até a entrega das chaves, garantindo segurança, transparência e cumprimento das etapas."
      ],
      "groups": [
        {
          "title": "PRINCIPAIS RESPONSABILIDADES DO PÓS-CONTRATO",
          "items": [
            "Acompanhar todo o processo após a assinatura do contrato até a conclusão definitiva da negociação.",
            "Atuar como ponto de apoio entre compradores, vendedores, corretores, gerentes, cartórios, instituições financeiras e demais envolvidos.",
            "Manter comunicação constante com todas as partes, fornecendo atualizações sobre o andamento da negociação.",
            "Registrar a venda no CRM e manter todos os sistemas da empresa atualizados.",
            "Criar e gerenciar o fluxo operacional da venda nas plataformas internas.",
            "Organizar, conferir, digitalizar e arquivar toda a documentação da negociação.",
            "Solicitar e acompanhar o envio da documentação de compradores e vendedores.",
            "Emitir, solicitar e organizar certidões, matrículas, pesquisas de ônus e demais documentos necessários para conclusão da negociação.",
            "Acompanhar todos os prazos contratuais para o cumprimento das etapas previstas.",
            "Acompanhar pagamentos previstos em contrato, incluindo sinal, parcelas intermediárias, saldo final e demais obrigações financeiras.",
            "Monitorar o recebimento das comissões e acompanhar a emissão de notas fiscais, recibos e documentos financeiros.",
            "Acompanhar a elaboração, conferência e aprovação de minutas de escritura e contratos bancários.",
            "Solicitar e acompanhar a emissão das guias de ITBI.",
            "Acompanhar as assinaturas da escritura ou dos contratos de financiamento.",
            "Acompanhar o envio da documentação aos cartórios e instituições financeiras.",
            "Monitorar registros imobiliários, averbações e exigências cartorárias até sua conclusão.",
            "Acompanhar prazos dos cartórios e acompanhar a efetivação do registro.",
            "Acompanhar processos de financiamento imobiliário junto aos bancos e correspondentes bancários.",
            "Monitorar aprovação de crédito, envio de documentos, emissão dos contratos e liberação dos recursos financeiros.",
            "Acompanhar a emissão da certidão de ônus atualizada após o registro da escritura.",
            "Acompanhar a alteração da titularidade do imóvel junto aos órgãos competentes (IPTU).",
            "Realizar o encontro de contas entre comprador e vendedor, verificando IPTU, condomínio, água, energia, gás e demais encargos incidentes sobre o imóvel.",
            "Garantir que compradores e vendedores recebam toda a documentação final da negociação.",
            "Registrar todas as etapas, documentos e ocorrências nos sistemas internos da empresa.",
            "Apoiar corretores e gerentes na resolução de problemas relacionados ao processo de pós-contrato.",
            "Garantir o cumprimento dos procedimentos internos e dos padrões de qualidade da 61 Imóveis.",
            "Zelar pela segurança jurídica e documental de todas as negociações.",
            "Promover uma experiência de excelência para clientes durante todo o processo após a assinatura do contrato, fortalecendo a credibilidade e o diferencial da 61 Imóveis."
          ]
        }
      ]
    },
    {
      "title": "MARKETING",
      "intro": [],
      "groups": [
        {
          "title": "PRINCIPAIS RESPONSABILIDADES DO MARKETING",
          "items": [
            "Desenvolver e executar a estratégia de comunicação e posicionamento da 61 Imóveis.",
            "Fortalecer a marca e garantir a aplicação correta da identidade visual em todos os canais de comunicação.",
            "Planejar e executar campanhas institucionais, comerciais, promocionais e de endomarketing.",
            "Produzir conteúdos para redes sociais, site, portais imobiliários e demais canais digitais da empresa, conforme demanda aprovada.",
            "Criar artes gráficas para campanhas internas e externas da empresa.",
            "Produzir materiais institucionais e comerciais da empresa.",
            "Produzir vídeos institucionais, comerciais, treinamentos e conteúdos para redes sociais da empresa.",
            "Planejar, gravar e editar vídeos para divulgação de imóveis, campanhas e ações da empresa, conforme demanda aprovada.",
            "Realizar cobertura fotográfica e audiovisual de eventos, treinamentos e ações internas.",
            "Administrar os perfis oficiais da empresa nas redes sociais.",
            "Desenvolver o calendário editorial das redes sociais.",
            "Monitorar o desempenho das publicações e propor melhorias contínuas.",
            "Produzir campanhas de lançamento, captação, vendas, locação e ações internas sob demanda.",
            "Apoiar eventos, convenções, premiações, treinamentos e demais ações corporativas com materiais de comunicação.",
            "Produzir materiais de apoio para apresentações comerciais.",
            "Apoiar a Diretoria Comercial no desenvolvimento de campanhas estratégicas.",
            "Apoiar o RH nas ações de comunicação interna, endomarketing e fortalecimento da cultura organizacional.",
            "Manter comunicação contínua com os solicitantes durante o andamento das demandas.",
            "Gerenciar o banco de imagens, vídeos, artes e materiais institucionais.",
            "Monitorar indicadores de desempenho das campanhas e ações de marketing.",
            "Elaborar relatórios de resultados e propor melhorias nas estratégias de comunicação.",
            "Atuar de forma integrada com os setores Comercial, RH, HUB Administrativo, Pós-Contrato, Locação e Diretoria.",
            "Zelar pela imagem, reputação e fortalecimento da marca 61 Imóveis em todos os pontos de contato com clientes, parceiros, fornecedores e colaboradores."
          ]
        }
      ]
    },
    {
      "title": "JURÍDICO",
      "intro": [],
      "groups": [
        {
          "title": "PRINCIPAIS RESPONSABILIDADES DO JURÍDICO",
          "items": [
            "Prestar orientação jurídica à Diretoria e aos Gestores.",
            "Esclarecer dúvidas jurídicas relacionadas às negociações imobiliárias, sempre por meio da Diretoria ou dos Gestores.",
            "Emitir pareceres jurídicos para apoiar a tomada de decisões da empresa.",
            "Analisar questões jurídicas relacionadas aos imóveis e às negociações quando solicitado pela diretoria.",
            "Apoiar a regularização documental de imóveis e das partes envolvidas.",
            "Auxiliar na resolução de conflitos relacionados às negociações, quando demandado pelos gestores.",
            "Desenvolver, revisar e atualizar contratos, minutas e documentos jurídicos da empresa por demanda do diretor.",
            "Orientar a empresa sobre alterações na legislação aplicável ao mercado imobiliário.",
            "Prestar suporte jurídico preventivo para reduzir riscos nas negociações.",
            "Ser consultado sempre que houver dúvidas jurídicas, documentais ou contratuais antes do prosseguimento de qualquer negociação pelos gestores.",
            "Zelar pela segurança jurídica das operações realizadas pela 61 Imóveis."
          ]
        },
        {
          "title": "COMO FUNCIONA O ATENDIMENTO DO JURÍDICO",
          "items": [
            "O Jurídico atua exclusivamente sob demanda.",
            "O setor não realiza atendimento direto aos corretores.",
            "Toda solicitação deve ser encaminhada pelo Gerente Comercial, Gerente de Pós-Contrato ou pela Diretoria.",
            "O Jurídico não participa das negociações comerciais nem do atendimento aos clientes, atuando exclusivamente na análise e orientação jurídica das demandas encaminhadas.",
            "Seu papel é oferecer segurança jurídica às operações da empresa, garantindo que todos os processos estejam em conformidade com a legislação e os padrões da 61 Imóveis.",
            "Atuar preventivamente na identificação e resolução de pendências que possam comprometer a conclusão da negociação, analisando os documentos disponibilizados no momento do Parecer Jurídico."
          ]
        }
      ]
    },
    {
      "title": "INTELIGÊNCIA IMOBILIÁRIA",
      "intro": [
        "É a área responsável por transformar dados em decisões estratégicas, garantindo que a operação comercial da 61 Imóveis seja orientada por indicadores, qualidade da informação e inteligência de mercado. Além de monitorar o desempenho da carteira de imóveis, o setor desenvolve análises, identifica oportunidades de melhoria e fornece informações essenciais para aumentar a produtividade dos corretores, fortalecer as captações e impulsionar os resultados da empresa.",
        "Como um dos grandes diferenciais da 61 Imóveis, a área é responsável pela gestão do Inteligência 61 Imóveis, sistema próprio desenvolvido pela empresa para centralizar informações estratégicas da operação comercial, permitindo maior controle, acompanhamento e desenvolvimento da performance dos corretores."
      ],
      "groups": [
        {
          "title": "PRINCIPAIS RESPONSABILIDADES DA INTELIGÊNCIA 61",
          "items": [
            "Administrar e desenvolver o sistema Inteligência 61 Imóveis, garantindo sua evolução contínua e o funcionamento de todos os módulos.",
            "Gerenciar as funcionalidades da Jornada de Captação, Lançamento de Visitas, Ranking e demais módulos, aplicativos e sistemas utilizados pela empresa.",
            "Desenvolver novos recursos, indicadores e melhorias para apoiar a operação comercial.",
            "Transformar dados da operação em informações estratégicas para apoiar a tomada de decisão.",
            "Elaborar dashboards, relatórios gerenciais e análises de desempenho.",
            "Produzir relatórios sobre conversão de leads, captações, visitas, vendas e demais indicadores comerciais, sob demanda da diretoria.",
            "Produzir estudos de mercado para apoiar a atuação comercial e o posicionamento estratégico da empresa.",
            "Realizar monitoramento do mercado imobiliário e coleta de dados relevantes para a operação.",
            "Apoiar a Diretoria Comercial na definição de estratégias baseadas em dados.",
            "Integrar informações entre os setores Comercial, HUB Administrativo, Marketing, Pós-Contrato e Diretoria.",
            "Garantir a confiabilidade das informações do sistema utilizadas pela empresa.",
            "Identificar oportunidades de melhoria nos processos comerciais por meio da análise de dados.",
            "Atuar como referência em análise de dados, inovação e inteligência comercial, contribuindo para que a 61 Imóveis tome decisões cada vez mais rápidas, precisas e orientadas por dados."
          ]
        }
      ]
    }
  ],
  "managerIntro": [
    "A gestão comercial da 61 Imóveis tem como objetivo desenvolver pessoas, fortalecer equipes e garantir que a metodologia e os processos da empresa sejam executados com excelência.",
    "Cada corretor integra uma equipe comercial e conta com o acompanhamento de um Gerente Comercial, que será seu principal ponto de apoio durante toda a sua trajetória na empresa.",
    "Cada equipe será composta por até 10 corretores, podendo contar com 11 corretores pelo período máximo de 6 meses.",
    "O relacionamento entre gerente e corretor deve ser baseado em:"
  ],
  "managerPrinciples": [
    "Respeito",
    "Ética",
    "Transparência",
    "Desenvolvimento profissional",
    "Colaboração",
    "Foco em resultados",
    "Compromisso com os interesses da empresa e dos clientes."
  ],
  "managerClosing": "Mais do que acompanhar números, o gerente é responsável por desenvolver pessoas, formar profissionais de alta performance e garantir que cada corretor execute corretamente a estratégia da 61 Imóveis.",
  "managerResponsibilities": [
    "Sempre que uma nova captação for realizada pela equipe, o Gerente Comercial deverá entrar em contato com o proprietário para acompanhar a captação e fortalecer o relacionamento com o cliente.",
    "Liderar e desenvolver sua equipe de corretores.",
    "Garantir a execução da metodologia comercial da 61 Imóveis.",
    "Acompanhar indicadores, metas e resultados da sua equipe.",
    "Realizar reuniões individuais periódicas com cada corretor.",
    "Definir estratégias comerciais para captação, atendimento, visitas, propostas e fechamento de negócios.",
    "Orientar negociações e apoiar casos de maior complexidade.",
    "Acompanhar diariamente as visitas lançadas pelos corretores e definir estratégias de conversão.",
    "Conduzir reuniões semanais de captação com cada corretor.",
    "Acompanhar clientes com alto número de visitas sem proposta.",
    "Validar estratégias antes da apresentação de propostas aos proprietários.",
    "Conferir contratos e documentos antes da assinatura.",
    "Garantir que imóveis, anúncios e negociações atendam aos padrões da empresa.",
    "Solicitar apoio aos setores internos sempre que necessário.",
    "Promover treinamentos e compartilhar boas práticas.",
    "Cobrar disciplina, organização e cumprimento dos processos internos.",
    "Zelar pela imagem da empresa e pela excelência no atendimento aos clientes.",
    "Auxiliar o corretor a entender o Parecer Jurídico.",
    "Supervisionar os contratos de compra e venda da empresa.",
    "Acompanhar o fluxo contratual desde a negociação até a assinatura.",
    "Acompanhar aditivos, negociações e demais alterações contratuais.",
    "Gerenciar todo o processo de Pós-Contrato até a conclusão da venda.",
    "Acompanhar processos de financiamento, escrituração, registro e demais etapas necessárias para a efetivação do negócio.",
    "Acompanhar o desempenho das captações realizadas pela equipe comercial.",
    "Definir campanhas comerciais, incentivos e estratégias de crescimento.",
    "Acompanhar a produtividade de corretores e sua equipe."
  ],
  "contractIntro": [
    "O gerente é o responsável pela elaboração e validação comercial dos contratos referentes às negociações realizadas por sua equipe.",
    "Mesmo quando houver apoio do Jurídico, permanece sob sua responsabilidade:"
  ],
  "contractResponsibilities": [
    "Conferir documentação;",
    "Validar valores e condições negociadas;",
    "Garantir a conformidade da negociação;",
    "Autorizar a assinatura dos contratos;",
    "Confeccionar o contrato e Termos Aditivos."
  ],
  "contractClosing": "Nos contratos e Termos Aditivos, o gerente é responsável pelas informações e condições comerciais negociadas.",
  "teamIntro": [
    "O gerente deve atuar como mentor dos corretores, acompanhando sua evolução profissional e auxiliando na construção de resultados consistentes.",
    "É sua responsabilidade:"
  ],
  "teamResponsibilities": [
    "Desenvolver competências técnicas e comerciais;",
    "Identificar dificuldades e oportunidades de melhoria;",
    "Estimular o aprendizado contínuo;",
    "Incentivar o cumprimento das metas;",
    "Promover um ambiente colaborativo e produtivo.",
    "Acompanhar os anúncios nos portais e verificar a entrada de novos leads;",
    "Fazer o acompanhamento dos leads;",
    "Acompanhar e verificar as visitas realizadas;",
    "Acompanhar as propostas em andamento;",
    "Realizar feedbacks trimestrais sobre o desempenho dos corretores.",
    "Não é permitido alterar o status de uma captação sem prévia comunicação com a Diretoria.",
    "Não é permitido acessar autorizações de captações de outras equipes."
  ],
  "conductIntro": [
    "Além da liderança operacional, espera-se que o gerente mantenha um ambiente de trabalho ético, respeitoso e colaborativo."
  ],
  "conductRestrictions": [
    "Assediar ou incentivar a migração de corretores pertencentes a outras equipes.",
    "Adotar condutas que prejudiquem outras equipes ou os interesses da empresa.",
    "Utilizar sua posição para obtenção de vantagens pessoais.",
    "Descumprir ou flexibilizar processos internos sem autorização."
  ]
};
